

import React, { useState, useRef, useEffect } from "react";
import { FaFilePdf } from "react-icons/fa";

function ActionsDropdown({
    row,
    permissions = {},
    onEdit,
    onDelete,
    onInfo,
    onUpdateStatus,
    onLock,
    onPrint,
    onDownload,
    onPdfDownload,
    onAssign,
    label = "Actions",
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // If no actions are available, don't render anything
    const hasActions =
        (permissions.edit && onEdit) ||
        (permissions.delete && onDelete) ||
        onInfo;

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [isOpen]);

    if (!hasActions) return null;

    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const handleAction = (callback, id, row) => {
        callback(id, row);
        setIsOpen(false);
    };

    return (
        <div className="dropdown" ref={dropdownRef} style={{ position: 'relative' }}>
            <button
                className="btn btn-secondary dropdown-toggle btn-sm"
                type="button"
                onClick={handleToggle}
                aria-expanded={isOpen}
                style={{ visibility: isOpen ? 'hidden' : 'visible', borderRadius: "4px", padding: "0px 3px", fontWeight: "600", width: "80px" }}
            >
                {label}
            </button>

            <ul
                className={`dropdown-menu${isOpen ? ' show' : ''}`}
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    margin: 0,
                    minWidth: '120px',
                    width: 'auto'
                }}
            >
                {permissions.edit && onEdit && (
                    <li>
                        <button
                            className="dropdown-item"
                            onClick={() => handleAction(onEdit, row._id, row)}
                        >
                            <i className="fas fa-edit me-2"></i>
                            Edit
                        </button>
                    </li>
                )}
                {onUpdateStatus && (
                    <li>
                        <button
                            className="dropdown-item"
                            onClick={() => onUpdateStatus(row._id, row)}
                        >
                            <i class="fa-solid fa-user-tag"></i>    Update Status
                        </button>
                    </li>
                )}
                {onInfo && (
                    <li>
                        <button
                            className="dropdown-item"
                            onClick={() => handleAction(onInfo, row._id, row)}
                        >
                            <i className="fas fa-info-circle me-2"></i>
                            Info
                        </button>
                    </li>
                )}
                {onPrint && (
                    <li>
                        <button
                            className="dropdown-item"
                            onClick={() => onPrint(row)}
                        >
                            <i className="fa-solid fa-print"></i> Print
                        </button>
                    </li>
                )}
                {onLock && (
                    <li>
                        <button
                            className="dropdown-item"
                            onClick={() => {
                                onLock(row._id, row);
                                setIsOpen(false);
                            }}
                        >
                            <i class="fa-solid fa-lock"></i> Lock
                        </button>
                    </li>
                )}
                {onAssign && (
                    <li>
                        <button
                            className="dropdown-item"
                            onClick={() => onAssign(row._id, row)}
                        >
                            <i class="fa-solid fa-user-tag"></i>    Assign
                        </button>
                    </li>
                )}
                {permissions.download && onDownload && (
                    <li>
                        <button
                            className="dropdown-item"
                            onClick={() => onDownload(row._id, row)}
                        >
                            <i className="fa-solid fa-print"></i> Print
                        </button>
                    </li>
                )}
                {permissions.download && onPdfDownload && (
                    <li>
                        <button
                            className="dropdown-item"
                            onClick={() => onPdfDownload(row._id, row)}
                        >
                            <FaFilePdf /> Pdf
                        </button>
                    </li>
                )}

                {permissions.delete && onDelete && (
                    <li>
                        <button
                            className="dropdown-item"
                            onClick={() => handleAction(onDelete, row._id, row)}
                        >
                            <i className="fas fa-trash me-2"></i>
                            Delete
                        </button>
                    </li>
                )}
            </ul>
        </div>
    );
}

export default ActionsDropdown;